import React from 'react';
import { Button, Dialog, DialogTitle } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as CashWalletSuccessCheckIcon } from '@/img/icons/cash-wallet-success-check-icon.svg';

const TITLE_ID = 'cash-wallet-success-title';

const SuccessDialog = ({ open, shortId, email, onClose }) => {
    const { t } = useTranslation('CashWallet');

    return (
        <Dialog open={open} onClose={onClose} className="cash-wallet-success-dialog" aria-labelledby={TITLE_ID}>
            <div className="cash-wallet-success-content">
                <div className="cash-wallet-success-icon-wrap">
                    <CashWalletSuccessCheckIcon className="cash-wallet-success-icon" />
                </div>
                <div className="cash-wallet-success-text">
                    <DialogTitle id={TITLE_ID} className="cash-wallet-success-title">
                        {t('Success.Title')}
                    </DialogTitle>
                    <div className="cash-wallet-success-id">
                        <Trans
                            t={t}
                            i18nKey="Success.PaymentRequestId"
                            values={{ shortId }}
                            components={[<strong key="0" className="cash-wallet-success-id-strong" />]}
                        />
                    </div>
                    <div className="cash-wallet-success-body">{t('Success.Body', { email })}</div>
                </div>
            </div>
            <div className="cash-wallet-success-actions">
                <Button
                    className="cash-wallet-success-cta"
                    variant="contained"
                    color="primary"
                    disableElevation
                    sx={{ textTransform: 'none' }}
                    onClick={onClose}
                >
                    {t('Success.GotIt')}
                </Button>
            </div>
        </Dialog>
    );
};

export default SuccessDialog;
